import { EntityRepository, Repository } from "typeorm";
import { NonSoakedProductsEntity } from "../entities/non-soaked-products.entity";


@EntityRepository(NonSoakedProductsEntity)
export class NonSoakedProductsRepository extends Repository<NonSoakedProductsEntity> {


}